module.exports = __webpack_public_path__ + "static/banner-cb089a3da0a2ed91c2dda99a1f8a9be7.png";